import React from 'react';
import cookie from 'cookie';
import { sortOptionPVInsertTime } from '../../helpers/helpers';

const getCookie = () => cookie.parse(document.cookie);

const getCookieValue = key => getCookie()[key];

const setCookieValue = (key, value, options) => {
  document.cookie = cookie.serialize(key, value, options);
};

const animateScroll = (container, destination, duration) => {
  if (duration > 0) {
    const difference = destination - container.scrollTop;
    const step = (difference / duration) * 10;

    setTimeout(() => {
      top.window.scroll(0, container.scrollTop + step);
      if (container.scrollTop !== destination) {
        animateScroll(container, destination, duration - 10);
      }
    }, 5);
  }
};

const containerAnimateScroll = (container, from, destination, isScrollDown, duration) => {
  if (duration > 0) {
    const difference = isScrollDown ? destination - container.offsetTop : destination + container.offsetTop;
    const step = (difference / duration) * 10;

    setTimeout(() => {
      const to = isScrollDown ? from + step : from - step;
      container.scroll(from, to);
      if (container.scrollTop !== destination) {
        containerAnimateScroll(container, from, destination, isScrollDown, duration - 10);
      }
    }, 5);
  }
};

const isOverflowScrollDown = (newElem, oldElem) => newElem.offsetTop > oldElem.offsetTop;
const overflowDestination = (isScrollDown, newElem, oldElem) =>
  isScrollDown ? newElem.offsetTop - oldElem.offsetTop : oldElem.offsetTop - newElem.offsetTop;

const sortOptions = [
  { label: 'Sort By', value: sortOptionPVInsertTime },
  { label: 'New Arrivals', value: sortOptionPVInsertTime },
  { label: 'Price (Highest First)', value: 'price_desc' },
  { label: 'Price (Lowest First)', value: 'price_asc' }
];

const formatNum = (input = 0) => parseFloat(input).toFixed(2);

const genRandomStr = () => (Math.random() + 3.14159265359).toString(36).substring(2);

const separateProductDataIntoRows = products => {
  let groupOfFour = [];

  return products.reduce((acc, product, index) => {
    groupOfFour.push(product);
    if (groupOfFour.length === 4 || index === products.length - 1) {
      acc.push(groupOfFour);
      groupOfFour = [];
    }
    return acc;
  }, []);
};

// Products are delivered in multiples of 60 from the backend. Skips are restricted
// to multiples of 60 even if the user manually changes the skip in the URL
const roundDownToMultipleOf60 = skip => {
  if (isNaN(skip)) {
    return 0;
  }
  return skip % 60 === 0 ? skip : roundDownToMultipleOf60(skip - 1);
};

const getPrevSkipAmount = skip => (skip - 60 > 0 ? skip - 60 : 0);

const getNextSkipAmount = (skip, total) => (skip + 60 < total ? skip + 60 : 0);

const isNumber = num => !isNaN(Number(num));

const tag = ([raw]) => {
  const [labelBgColor, labelColor, label, ...message] = raw.split(' ');
  const tagCss = `
    color: ${labelColor};
    background-color: ${labelBgColor};
    font-weight: bold;
    padding: 0 .5em 0 .5em
  `;
  return [`%c${label}:%c ${message.join(' ')}`, tagCss, ''];
};

const callbackFnWithTimeout = (callback, time = 1000) => {
  let called = false;
  const fn = () => {
    if (!called) {
      called = true;
      callback();
    }
  };
  setTimeout(fn, time);
  return fn;
};

const getCreditCardType = number => {
  let re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
  if (number.match(re) !== null) {
    return 'Visa Electron';
  }

  re = new RegExp('^4');
  if (number.match(re) !== null) {
    return 'Visa';
  }

  re = new RegExp('^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$');
  if (re.test(number)) {
    return 'Mastercard';
  }

  re = new RegExp('^3[47]');
  if (number.match(re) !== null) {
    return 'AMEX';
  }

  re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)');
  if (number.match(re) !== null) {
    return 'Discover';
  }

  re = new RegExp('^36');
  if (number.match(re) !== null) {
    return 'Diners';
  }

  re = new RegExp('^30[0-5]');
  if (number.match(re) !== null) {
    return 'Diners - Carte Blanche';
  }

  re = new RegExp('^35(2[89]|[3-8][0-9])');
  if (number.match(re) !== null) {
    return 'JCB';
  }

  return '';
};

const invalidCcNumCheck = (num, isUsd) => {
  num = num.replace(/\s/g, '');
  if (!isNumber(num) || num.length < 14) {
    return true;
  }

  const cardType = getCreditCardType(num);
  let supportedCards = ['Visa', 'Visa Electron', 'Mastercard'];
  if (isUsd) {
    supportedCards = [...supportedCards, 'AMEX', 'JCB'];
  }

  return !supportedCards.includes(cardType);
};

export {
  animateScroll,
  invalidCcNumCheck,
  formatNum,
  genRandomStr,
  getCookie,
  getCookieValue,
  getCreditCardType,
  getNextSkipAmount,
  getPrevSkipAmount,
  isNumber,
  roundDownToMultipleOf60,
  separateProductDataIntoRows,
  setCookieValue,
  sortOptions,
  tag,
  containerAnimateScroll,
  isOverflowScrollDown,
  overflowDestination
};
